import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetMainstayCacheApi } from '@/apis/basics/mainstay.api';

const { wsCache } = useCache();
const CacheKey = 'MainstayCacheList';

export const useMainstay = defineStore('mainstay_maps', {
	state: (): any => ({
		mainstayList: [] as any[],
		mainstayMap: {} as any,
	}),
	getters: {},
	actions: {
		getName(itemId: string) {
			if (!itemId) return '--';
			return this.mainstayMap.get(itemId) ?? '--';
		},
		async setMainstayMaps() {
			let dataList = wsCache.get(CacheKey);

			if (!dataList) {
				//dataList = await this.getDataList();
			}
      dataList = await this.getDataList();

			/* 设置下拉数据列表(生效的数据) */
			this.mainstayList = dataList
				.filter((item: any) => item.is_enabled == 'Y')
				.map((item: any) => {
					return { value: item.id, label: item.mainstay_name };
				});

			/* 设置映射 */
			const dataMap = new Map();
			dataList.forEach((item: any) => {
				dataMap.set(item.id, item.mainstay_name);
			});

			this.mainstayMap = dataMap;
		},
		getDataList() {
			return new Promise((resolve) => {
				GetMainstayCacheApi().then((res: any) => {
					const dataList = res.data || [];
					//wsCache.set(CacheKey, dataList);
					resolve(dataList);
				});
			});
		},
	},
});
